module.exports = __webpack_public_path__ + "img/Moment.5aefd766.svg";